import { render } from "./TheHeader.vue?vue&type=template&id=6a38bc36&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=6a38bc36&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6a38bc36"

export default script